import { useTranslation } from 'react-i18next'

import { Icon } from '@iconify/react'
import { toolTipAtrributes } from 'src/utils'
import { Fragment } from 'react'

import "./style.css"

type TabItem = {
    key: number,
    action?: () => void,
    actionName?: string,
    icon?: string,
    isDisabled?: boolean,
    label: string
}

type NavTabsProps = {
    tabs: TabItem[]
    setSelectedTab: Function
    selectedTab: number
    tabClassName?: string
    disabledTabs?: number[]
}

const NavTabs = ({ tabs, selectedTab, setSelectedTab, tabClassName, disabledTabs }: NavTabsProps) => {
    const { t } = useTranslation()

    return (
        <div className={`nav-tabs-container row`}>
            {tabs.map((value, index) => {
                const tabNum = Number(value.key)
                const isActive = selectedTab === tabNum
                const isDisabled = disabledTabs?.includes(tabNum)
                return (
                    <Fragment key={index}>
                        <div
                            onClick={() => !isDisabled && setSelectedTab(tabNum)}
                            className={`nav-tab ${tabClassName} ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                        >
                            {value.action &&
                                <div className='tabAction'>
                                    <div
                                        className={` tabActionIcon ${value.isDisabled ? 'disabled' : ''}`}
                                        {...(value.action ? { onClick: (e) => { e.stopPropagation(); !value.isDisabled && value.action?.() } } : { onClick: () => { } })}
                                        {...(toolTipAtrributes(`${t(value.actionName || "")}`, "top", false) as React.HTMLAttributes<HTMLDivElement>)}
                                    >
                                        <Icon icon={value.icon || ''}
                                            width={20}
                                            height={20}
                                        />
                                    </div>

                                </div>
                            }
                            <div className=" d-flex  justify-content-center">
                                {t(value.label)}

                            </div>
                        </div>
                    </Fragment>
                )
            })}
        </div >
    )
}

export default NavTabs